/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AttributeTypeDTO } from './AttributeTypeDTO';
import {
    AttributeTypeDTOFromJSON,
    AttributeTypeDTOFromJSONTyped,
    AttributeTypeDTOToJSON,
} from './AttributeTypeDTO';

/**
 * 
 * @export
 * @interface AttributeFilterDTO
 */
export interface AttributeFilterDTO {
    /**
     * 
     * @type {AttributeTypeDTO}
     * @memberof AttributeFilterDTO
     */
    attributeType: AttributeTypeDTO;
}



/**
 * Check if a given object implements the AttributeFilterDTO interface.
 */
export function instanceOfAttributeFilterDTO(value: object): value is AttributeFilterDTO {
    if (!('attributeType' in value) || value['attributeType'] === undefined) return false;
    return true;
}

export function AttributeFilterDTOFromJSON(json: any): AttributeFilterDTO {
    return AttributeFilterDTOFromJSONTyped(json, false);
}

export function AttributeFilterDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AttributeFilterDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeType': AttributeTypeDTOFromJSON(json['attributeType']),
    };
}

export function AttributeFilterDTOToJSON(value?: AttributeFilterDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeType': AttributeTypeDTOToJSON(value['attributeType']),
    };
}

